// Common search query: /web-design-cost → /pricing (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/web-design-cost")({
  beforeLoad: () => {
    throw redirect({ to: "/pricing", statusCode: 301 });
  },
});
